/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Image_Subtitles_DescInputs */



/**
* | output |
* | --- |
* | "PNG or TIFF images with BDN, Scenarist SST, and FCP XML" |
*
* @param {File_Export_Image_Subtitles_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_image_subtitles_desc = /** @type {((inputs?: File_Export_Image_Subtitles_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Image_Subtitles_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Images PNG ou TIFF avec BDN, SST Scenarist et XML FCP")
	if (locale === "de") return /** @type {LocalizedString} */ ("PNG- oder TIFF-Bilder mit BDN, Scenarist-SST und FCP-XML")
	if (locale === "it") return /** @type {LocalizedString} */ ("Immagini PNG o TIFF con BDN, SST Scenarist e XML FCP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("PNG или TIFF изображения с BDN, Scenarist SST и FCP XML")
	if (locale === "es") return /** @type {LocalizedString} */ ("Imagenes PNG o TIFF con BDN, Scenarist SST y FCP XML")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("带有 BDN、Scenarist SST 和 FCP XML 的 PNG 或 TIFF 图像")
	if (locale === "ja") return /** @type {LocalizedString} */ ("BDN、Scenarist SST、FCP XML 付きの PNG または TIFF 画像")
	if (locale === "hi") return /** @type {LocalizedString} */ ("BDN, Scenarist SST और FCP XML के साथ PNG या TIFF छवियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Imagens PNG ou TIFF com BDN, SST Scenarist e XML FCP")
	return /** @type {LocalizedString} */ ("PNG or TIFF images with BDN, Scenarist SST, and FCP XML")
});